import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
const STATS = [{
  value: '03',
  en: 'Bedrooms',
  es: 'Habitaciones'
}, {
  value: '2.5',
  en: 'Bathrooms',
  es: 'Baños'
}, {
  value: '1,622',
  en: 'Sq Ft',
  es: 'Pies²'
}, {
  value: '2023',
  en: 'Year Built',
  es: 'Año de Construcción'
}, {
  value: '01',
  en: 'Car Garage',
  es: 'Garaje'
}];
export function StatsSection() {
  const {
    lang,
    t
  } = useLanguage();
  return <section id="property" className="w-full bg-ivory py-20 lg:py-28" data-id="element-419" data-mp="1dvebx1mbaidn">
      <div className="mx-auto max-w-editorial px-5 lg:px-8" data-id="element-420" data-mp="18tyo51sr1xrk">
        <Reveal data-id="element-421" data-mp="1nsak168at2ho">
          <h2 className="max-w-[20ch] font-display text-[34px] font-semibold uppercase leading-[1.02] text-midnight sm:text-[44px] lg:text-[54px]" data-id="element-422" data-mp="1nqpphglzhjjt">
            {t('Everything You Need, Ready to Enjoy', 'Todo lo que Necesitas, Listo para Disfrutar')}
          </h2>
          <div className="gold-rule mt-8 w-full" data-id="element-423" data-mp="3kkauaod5kz0l" />
        </Reveal>

        <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:grid-cols-5" data-id="element-424" data-mp="3km42i83ezrap">
          {STATS.map((stat, index) => <Reveal key={stat.en} delay={index * 0.04} data-id="element-425" data-mp="wgo1305tn87v" data-mpi={index}>
              <div className="flex h-full flex-col" data-id="element-426" data-mp="wf36xbnf5raj">
                <dd className="font-display text-[46px] font-medium leading-none text-gold lg:text-[58px]" data-id="element-427" data-mp="11g0lle98037a">
                  {stat.value}
                </dd>
                <dt className="label-caps mt-3 text-ink/70" data-id="element-428" data-mp="168tumebq1xp6">
                  {lang === 'en' ? stat.en : stat.es}
                </dt>
              </div>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}